import '@/scss/theme.scss'

import Vue from 'vue'

// Filters
import '@/js/filters/currency'
import '@/js/filters/currencyFromCents'
import '@/js/filters/currencyWithoutCents'
import '@/js/filters/imageSize'
import '@/js/filters/discountPercentage'
import '@/js/filters/formattedProductTitle'

// Global components
import VueHeader from '@/js/components/vue-header.js'
import VueCollapsible from '@/js/components/vue-collapsible.vue'
import KeenSlider from '@/js/components/keen-slider.vue'
import ProductItem from '@/js/components/product-item.js'
import ResponsiveImage from '@/js/components/responsive-image.vue'
import ButtonSpinner from '@/js/components/button-spinner.vue'
import QuantityField from '@/js/components/quantity-field.vue'
import VideoWrapper from '@/js/components/video-wrapper.vue'
import MegamenuRecommendations from '@/js/components/megamenu-recommendations'
import MegamenuLinks from '@/js/components/megamenu-links'
import DragScrollWrapper from '@/js/components/drag-scroll-wrapper.vue'
import ValueProposition from '@/js/components/value-proposition'
import FieldValidation from '@/js/components/field-validation'
import SimilarProducts from '@/js/components/similar-products'
import MostPopularProducts from '@/js/components/most-popular-products'
import Newsletter from '@/js/components/newsletter'

// Template specific components
import ProductListAndFiltering from '@/js/templates/product-list-and-filtering.js'
import ProductDetail from '@/js/templates/product-detail'
import ProductRelated from '@/js/templates/product-related.js'
import CustomerAddresses from '@/js/templates/customer-addresses.js'
import CustomerLogin from '@/js/templates/customer-login.js'
import Cart from '@/js/templates/cart.js'
import ProductBestDeals from '@/js/templates/product-best-deals.js'
import ProductNewest from '@/js/templates/product-newest.js'
import ProductAppointment from '@/js/templates/product-appointment.js'
import Country from '@/js/templates/country.json'

Vue.component('ResponsiveImage', ResponsiveImage)
Vue.component('ButtonSpinner', ButtonSpinner)
Vue.component('QuantityField', QuantityField)
Vue.component('DragScrollWrapper', DragScrollWrapper)

const initVueInstance = element => {
  return new Vue({
    el: element,

    delimiters: ['${', '}'],

    components: {
      VueHeader,
      VueCollapsible,
      KeenSlider,
      ProductItem,
      VideoWrapper,
      MegamenuRecommendations,
      MegamenuLinks,
      ValueProposition,
      FieldValidation,
      SimilarProducts,
      MostPopularProducts,

      ProductListAndFiltering,
      ProductDetail,
      ProductRelated,
      CustomerAddresses,
      CustomerLogin,
      Cart,
      ProductBestDeals,
      ProductNewest,
      Newsletter,
      ProductAppointment,
      Country
    }
  })
}

const initVue = () => document.querySelectorAll('[vue-init]').forEach(element => {
  initVueInstance(element)
})

initVue()

// Fix for theme editor preview
document.addEventListener('shopify:section:load', (event) => {
  // Vue HTML tags disappear so it can't reinitialise, causing the header to break
  if (event.target.id.includes('megamenu')) return
  initVue()
})
